import 'es6-promise';
import 'isomorphic-fetch';
import * as Redux from 'redux';
import * as _ from 'lodash';
import * as actions from './index';
import { ISearchCriteria } from '../state-helpers/search-criteria'
import { ISort } from '../state-helpers/sorts'
import { ISearchAppState } from '../reducers/index'
import { IFacetResult } from '../state-helpers/facets';
import { pushInUrlQuery } from 'react-url-query';
import { updateSearchFacet, setSelectedFacetCount } from './index';
import { getParameterByName } from '../../global/functions/query-string';
import { IAnalytics } from '../../global/functions/analytics';
import { IResults, ISearchResult } from '../state-helpers/search-results';
import { isNullOrUndefined } from 'util';
import { ErrorConstants } from '../../global/constants/constants';

const fetch = (criteria: string) => {
    const { loginPageUrl } = (window as any).bootstrap;

    const init: RequestInit = {
        method: 'POST',
        body: criteria,
        headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
    };

    return window.fetch('/api/v1/search/searchWithCriteria/', init)
        .then(function (response) {
            // Catch the timeout
            if (response.status === 504) {
                const errorMsg = new Error(ErrorConstants.FailedToFetchMessage);
                errorMsg.message = ErrorConstants.FailedToFetchMessage;
                throw errorMsg;
            }
            else if (response.status === 401) {
                const errorMsg = new Error(ErrorConstants.UnauthorizedErrorMessage);
                errorMsg.message = ErrorConstants.UnauthorizedErrorMessage;
                window.location.replace(loginPageUrl + '?returnUrl=' + window.location.href);
                throw errorMsg;
            }
            // Catch the bad response
            else if (response.status >= 400) {
                const errorMsg = new Error(ErrorConstants.BadReponseMessage);
                errorMsg.message = ErrorConstants.BadReponseMessage;
                throw errorMsg;
            }
            return response.json();
        })
};

// What is this doing???
let searchResultsCache = _.memoize(fetch, (criteria: string) => criteria);

export enum FetchResultsFlags {
    None                = 0,
    IsPop               = 1 << 0,
    OnlyGetFacets       = 1 << 1,
    WithSuggestion      = 1 << 2,
    FromAutocomplete    = 1 << 3
}

// Function currying!
// This allows for functional dependency injection
// i.e. analytics is bound in mapDispatchToProps, then the component can call the function with flags
export const fetchResults = (analytics: IAnalytics) => (flags: FetchResultsFlags) => {

    const isPop = !!(flags & FetchResultsFlags.IsPop);
    const onlyGetFacets = !!(flags & FetchResultsFlags.OnlyGetFacets);
    const withSuggestion = !!(flags & FetchResultsFlags.WithSuggestion);
    const fromAutocomplete = !!(flags & FetchResultsFlags.FromAutocomplete);

    return (dispatch, getState) => {
        let state = getState() as ISearchAppState;
        var selectedSort = state.sortsModel.filter(s => s.selected)[0];
        var selectedContext = state.selectedSearchContext;

        var tags = getTags();
        var sortUrls = getSortUrls();

        var searchCriteria = JSON.stringify({
            SearchTerm: state.searchTermModel.trim(),
            Page: state.pageModel.page,
            PageSize: state.pageModel.pageSize,
            SortDirection: selectedSort.direction,
            SortField: selectedSort.sortField,
            Context: selectedContext.id,
            Facets: state.facetsModel.facets,
            IncludeSuggestion: withSuggestion,
            Tags: tags,
            SortUrls: sortUrls
        })

        dispatch(actions.itemsAreLoading(true));
        searchResultsCache(searchCriteria)
            .then(function (data) {
                let facetsData = data.data.facets as IFacetResult[];
                setFacetsAndCount(dispatch, facetsData);

                // On page load of a new page we want to display facets but no results
                if (onlyGetFacets) {
                    dispatch(actions.showResults(false));
                    dispatch(actions.itemsAreLoading(false));
                }
                else {
                    dispatch(actions.showResults(true));
                    dispatch(actions.getResults(data.data, fromAutocomplete));

                    // Build title
                    const termSpacer = state.searchTermModel == '' ? '' : ' | ';
                    const searchSource = getParameterByName("source") === null ? " | AAP" : " | " + getParameterByName("source")

                    // A string that's sometimes the search term, but othertimes
                    // a JSON object encoding the term :/
                    let searchTerm = state.searchTermModel;
                    try {
                        const json = JSON.parse(searchTerm);
                        searchTerm = json[0].terms[0].term
                    } catch (err) {
                        // We good
                    }

                    const title = searchTerm + termSpacer + selectedContext.display + searchSource

                    // Limit length
                    document.title = title.substr(0, 59);

                    const results = data.data as IResults;
                    const noResults = results.searchItemList == null || results.searchItemList.length == 0;

                    if (fromAutocomplete && noResults) {
                        analytics.onZeroAutocompleteResults(selectedContext.display, state.searchTermModel.trim());
                    }
                }
            })
            .catch(err => {
                console.log(err);
                if (err.message === ErrorConstants.UnauthorizedErrorMessage) {
                    return;
                }
                dispatch(actions.updateResultsFailure(err.message))
            });
    }
}

interface ITag {
    Value: string;
}

function getTags(): string[] {
    var tags: ITag[] = (window as any).bootstrap.tags;
    if (tags != undefined && tags.length > 0) {
        return (window as any).bootstrap.tags;
    } else {
        return [];
    }
}

interface ISortUrl {
    Value: string;
}

function getSortUrls(): string[] {
    var sortUrls: ISortUrl[] = (window as any).bootstrap.sortUrls;
    if (sortUrls != undefined && sortUrls.length > 0) {
        return (window as any).bootstrap.sortUrls;
    } else {
        return [];
    }
}

export function getSelectedFacetCount(facets: IFacetResult[]) {
    var currentFacets = _.clone(facets);
    var selectedCount = 0;

    for (var facet = 0; facet < currentFacets.length; facet++) {
        var currentFilter = currentFacets[facet];

        for (var filter = 0; filter < currentFilter.terms.length; filter++) {
            var currentTerm = currentFilter.terms[filter];

            if (currentTerm.selected === true) {
                selectedCount++;
            }
        }
    }

    return selectedCount;
}

export function setFacetsAndCount(dispatch: Redux.Dispatch<ISearchAppState>, facets: IFacetResult[]) {

    dispatch(updateSearchFacet(facets));
    dispatch(setSelectedFacetCount(getSelectedFacetCount(facets)));
}